"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/OnboardingWizard/result/charts/HomeAffordabilityChart";

import type { FC } from "react";
import { NextImage } from "@/src/components/NextImage";
import { ONBOARDING_WIZARD_ASSETS } from "../../onboardingWizardAssets";
import { formatResultCompactCurrency } from "../formatResultCurrency";
import type { HomeAffordabilityChartPayload } from "../types";

const I18n = I18nUtil.createScoped(Translations);

interface HomeAffordabilityChartProps {
  data: HomeAffordabilityChartPayload;
}

/** Figma 96138:32118 — small house (on your own) + large house (with Ed). */
export const HomeAffordabilityChart: FC<HomeAffordabilityChartProps> = ({
  data,
}) => (
  <div
    className="relative mx-auto h-[224px] w-full max-w-[345px]"
    data-testid="result-home-chart"
  >
    <div
      className="absolute inset-x-6 top-[150px] border-t border-border_inverse_transparent10"
      aria-hidden
    />

    <div
      className="absolute left-[33px] top-[80px]"
      data-testid="result-home-house-own"
    >
      <NextImage
        src={ONBOARDING_WIZARD_ASSETS.homePlanGoalBg}
        alt=""
        width={68}
        height={70}
        className="h-[70px] w-[68px] object-contain object-bottom"
      />
    </div>

    <div
      className="absolute left-[174px] top-[38px]"
      data-testid="result-home-house-ed"
    >
      <NextImage
        src={ONBOARDING_WIZARD_ASSETS.nameBg}
        alt=""
        width={110}
        height={112}
        className="h-[112px] w-[110px] object-contain object-bottom"
      />
    </div>

    <div className="absolute left-10 top-[162px] flex flex-col gap-0.5">
      <p className="body_medium_s text-content_secondary">
        {I18n.t("On your own")}
      </p>
      <p className="title_xl text-content_primary">
        {formatResultCompactCurrency(data.onYourOwnHomePrice)}
      </p>
    </div>

    <div className="absolute left-[184px] top-[162px] flex flex-col gap-0.5">
      <p className="body_medium_s text-content_secondary">
        {I18n.t("With Ed")}
      </p>
      <p className="title_xl text-content_brand_primary">
        {formatResultCompactCurrency(data.withEdHomePrice)}
      </p>
    </div>
  </div>
);
